var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"blue-grey darken-4",attrs:{"src":_vm.imagen,"height":"180","width":"180","contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }